import AppRoutes from "./appRoute";

const allRoutes = [...AppRoutes];

export default allRoutes;
